import { IN_STOCK, SUBSCRIPTION_DEFAULT_BILLING_PERIOD, TIPO_RINNOVO_AUTOMATICO } from "../../../utils/constants/product";
import { getModuleDatas, getOptionsForSelections, getPaymentFrequencies } from "../product";

const getPacchettoPrices = (product, paymentFrequencies, priceKeys) => {
  if (paymentFrequencies.length > 1) {
    return {
      [paymentFrequencies[0]]: product[priceKeys[0]],
      [paymentFrequencies[1]]: product[priceKeys[1]]
    }
  } else {
    return { [paymentFrequencies[0]]: product[priceKeys[1]] && product[priceKeys[1]] > 0 ? product[priceKeys[1]] : product[priceKeys[0]], }

  }
}

export const getPacchettoInfos = (product, attributeSets, productAttributes, res) => {
  const pfs = getPaymentFrequencies(product, true);
  const paymentFrequencies = pfs?.frequencies || pfs;
  const paymentFrequenciesUids = pfs?.uids;
  if (pfs['error']) {
    res.status(500).send({ error: `Something failed during getPacchetti -> getPaymentFrequncies for /getPacchetti on sku : ${product.sku}!`, message: pfs['error'] });
  }
  const modulesData = getModuleDatas(product.items, productAttributes['tipo_consegna'])

  let entryBillingPeriod = 'Y';

  if (product.entry_billing_period === null) {
    if (product.tipo_abbonamento === null) {
      entryBillingPeriod = 'Y';
    } else {
      entryBillingPeriod = SUBSCRIPTION_DEFAULT_BILLING_PERIOD[productAttributes['tipo_abbonamento'][product.tipo_abbonamento]];
    }
  } else {
    entryBillingPeriod = SUBSCRIPTION_DEFAULT_BILLING_PERIOD[productAttributes['entry_billing_period'][product.entry_billing_period]];
  }
  return {
    typeId: product.type_id,
    sku: product.sku,
    name: product.name,
    paymentFrequencies,
    inStock: product.stock_status == IN_STOCK,
    optionsToSelect: getOptionsForSelections(product),
    price: !paymentFrequencies[0] ? product?.price_range?.maximum_price?.final_price?.value : null,
    customizable_options: product.options,
    prices: getPacchettoPrices(product, paymentFrequencies, ['full_price_high', 'full_price_low']),
    promotional: getPacchettoPrices(product, paymentFrequencies, ['promotional_price_high', 'promotional_price_low']),
    discountedPrices: getPacchettoPrices(product, paymentFrequencies, ['discounted_price_high', 'discounted_price_low']),
    isTrial: !!product.is_trial && !!product.trial_duration_qty && !!product.trial_duration_span,
    trialDuration: product.trial_duration_qty,  // only the duration but based on span! ex: 1 quarter if qty 1 and span Q, or 3 months if qty 3 and span M
    trialDurationSpan: productAttributes['trial_duration_span'][product.trial_duration_span], // M, Q , Y
    trialPrice: product.trial_price,
    autoRenew: product.tipo_rinnovo == TIPO_RINNOVO_AUTOMATICO,
    attributeSetName: attributeSets[product.attribute_set_id],
    cancellation_notice_days: product.cancellation_notice_days,
    paymentFrequenciesUids,
    no_bzt_export: !!product.no_bzt_export,
    zuora_completed: !!product.zuora_completed,
    fulfillment_enabled: !!product.fulfillment_enabled,
    modulesInCartQty: modulesData.modulesInCartQty,
    modules: modulesData.modules,
    requiredModules: modulesData.requiredModules,
    productTypeId: product.type_id,
    startupCost: product.startup_cost,
    variants: product.variants,
    configurable_options: product.configurable_options,
    entryBillingPeriod,
    buyable: !product.not_ecommerce_buyable,
    renewal_cancellation_info: product.renewal_cancellation_info,
    moreInfoLabel: product?.more_info_label,
    externalBuyLink: product?.external_buy_link,
    directCheckoutLabel: product?.direct_checkout_label,
    card_subtitle: product.card_subtitle,
    autore: product.autori,
    tipo_rinnovo: product.tipo_rinnovo,
    agentFormLink: product.agent_form_link,
    productSite: product.product_site,
  }
}


export const equalizePurchaseSlides = (swiper, update = true) => {
  const slides = swiper.$el[0].querySelectorAll('.slide');
  if (slides.length < 1) return
  slides.forEach(el => el.querySelector('.purchase-card-wrapper').style.height = null)
  const tallest = Array.from(slides).reduce((tallest: Element, slide: Element) => {
    return slide.querySelector('.purchase-card-wrapper').getBoundingClientRect().height > tallest.querySelector('.purchase-card-wrapper').getBoundingClientRect().height ? slide : tallest;
  });
  const h = ((tallest as HTMLElement).offsetHeight + 1) + 'px';
  slides.forEach(el => el.querySelector('.purchase-card-wrapper').style.height = h)

  setTimeout(() => { 
    /**purchase-card__top-area */
    slides.forEach(el => el.querySelector('.purchase-card__top-area').style.height = null)
    const tallestTopArea = Array.from(slides).reduce((tallestTopArea: Element, slide: Element) => {
      return slide.querySelector('.purchase-card__top-area').getBoundingClientRect().height > tallestTopArea.querySelector('.purchase-card__top-area').getBoundingClientRect().height ? slide : tallestTopArea;
    });
    const hTopArea = ((tallestTopArea as HTMLElement).querySelector('.purchase-card__top-area') as HTMLElement).offsetHeight + 'px';
  
    slides.forEach(el => el.querySelector('.purchase-card__top-area').style.height = hTopArea);
    setTimeout(() => {
      update && swiper?.update()
      console.log('Swiper updated after equalizePurchaseSlides')
    }, 0)
  },100)
}

export const observeScalapay = (section, cbk) => {
  const scalapayObserver = new MutationObserver((mutationsList, observer) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        // Controlla se il widget è stato aggiunto al DOM
        if (section.querySelector('scalapay-widget')) {
          console.log('Il widget di Scalapay è stato aggiunto al DOM!');
          setTimeout(() => {
            cbk();
            console.log('Swiper resized after scalapay')
          }, 100)

          // Smette di osservare dopo che lo ha trovato e ha eseguito la cbk
          observer.disconnect(); 
        }
      }
    }
  });
  
  // Avvia l'observer sul body della pagina per monitorare tutti i cambiamenti
  scalapayObserver.observe(document.body, { childList: true, subtree: true });
}
